module.exports = __webpack_public_path__ + "static/media/InvoiceOutgoingBIG.621f0cbe.svg";